import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialChangePasswordState = {
    password: null,
    confirm_password: null
};

export const ChangePasswordSchema = Yup.object().shape({
    password: Yup.string().required(),
    confirm_password: Yup.string().required(),
});

export const ChangePasswordFormFields = [
    { name: "password", title: "New Password", required: true, type: VALUE_TYPES.TEXT },
    { name: "confirm_password", title: "Confirm Password", required: true, type: VALUE_TYPES.PASSWORD }
];
